export const ru = {
    'empty-gallery-message': 'Ничего не найдено',
    'preview-error': 'При загрузке данных превью произошла ошибка. Попробуйте позже.',
    'remove-item-confirmation': 'Вы уверены, что хотите удалить файл «{name}»?'
};
